import { Button } from "@atoms/Button";
import DOMPurify from "dompurify";
import { enterpriseBenefits } from "./variables";

export const PlanFooter = () => {
  const PlanFooterElement = document.createElement("div");
  PlanFooterElement.className =
    "w-full bg-white p-6 flex flex-col gap-8 xl:flex-row xl:items-center";

  const wrapperButtonId = "enterprise-wrapper-button";

  PlanFooterElement.innerHTML = DOMPurify.sanitize(/* html */ `
        <div class="flex flex-col gap-8 flex-1">
            <div class="flex flex-col gap-2">
                <h3 class="text-blue-800 text-2xl font-medium ">
                    Enterprise
                </h3>

                <p class="text-gray-450 text-sm  lg:text-base lg:max-w-136">
                    Corporações e grupos empresariais com alto volume de dados, requisitos de compliance rigorosos e necessidade de suporte dedicado 
                </p>
            </div>

            <div class="grid gap-4 lg:grid-cols-2 lg:gap-14">
                ${enterpriseBenefits
                  .map(
                    (arrayBenefits) => /* html */ `
                    <div class="flex flex-col gap-4">
                        ${arrayBenefits
                          .map(
                            (benefit) => /* html */ `
                            <div class="flex gap-2">
                                <img 
                                    src="/static/icons/check.svg" 
                                    alt="check-icon" 
                                    class="w-5 h-5 object-contain" 
                                />
            
                                <p class="text-gray-800 text-sm ">${benefit}</p>
                            </div>
                        `,
                          )
                          .join("")}
                    </div>
                `,
                  )
                  .join("")}
            </div>
        </div>

        <div class="w-full h-0.25 bg-gray-100 xl:w-0.25 xl:h-72"></div>

        <div id="${wrapperButtonId}" class="flex flex-col gap-4 items-center md:flex-row-reverse md:justify-between xl:flex-col">
            <p class="text-center  text-sm text-brown-200 xl:max-w-62">
                Te enviaremos um plano personalizado.
            </p>
        </div>
    `);

  const wrapperButtonElement = PlanFooterElement.querySelector(
    `#${wrapperButtonId}`,
  );

  if (wrapperButtonElement) {
    wrapperButtonElement.appendChild(
      Button({
        className: "xl:hidden",
        variant: "darkBlue",
        text: "Fale conosco",
        onClick: () => window.open("https://www.google.com", "_blank"),
      }),
    );

    wrapperButtonElement.appendChild(
      Button({
        className: "hidden xl:flex",
        variant: "darkBlue",
        text: "Falar com especialista",
        onClick: () => window.open("https://www.google.com", "_blank"),
      }),
    );
  }

  return PlanFooterElement;
};
